/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'star': {
    width: 31,
    height: 31,
    viewBox: '0 0 31 31',
    data: '<g _fill="#27DBBD" fill-rule="evenodd"><circle pid="0" opacity=".103" cx="15.5" cy="15.5" r="15.5"/><path pid="1" d="M15.535 21.245l-3.62 1.902a1 1 0 01-1.45-1.054l.69-4.03a1 1 0 00-.287-.885L7.94 14.324a1 1 0 01.555-1.706l4.046-.587a1 1 0 00.753-.548l1.81-3.666a1 1 0 011.793 0l1.81 3.666a1 1 0 00.752.548l4.046.587a1 1 0 01.555 1.706l-2.928 2.854a1 1 0 00-.288.885l.691 4.03a1 1 0 01-1.45 1.054l-3.62-1.902a1 1 0 00-.93 0z"/></g>'
  }
})
